<template>
  <div>
    <header class="mb-12">
      <div class="header-new">
        <div class="img-logo">
          <!-- <img
            src="/logo/logo.png"
            height="80%"
          > -->
        </div>
        <div
          class="balance-txt mr-1"
          @click="ShowWallet()"
        >
          <div class="steper mr-1">
            <div class="d-flex align-items-center">
              <img
                src="data:image/webp;base64,UklGRnIOAABXRUJQVlA4WAoAAAAQAAAApwAApwAAQUxQSKUEAAABkIVt29lI38x0sNuZtW3btm3btm3btm3btm3vZo0i30HTNE3+/732MCImgCxvr9VmxtI1T3672Ujl7dv753fMH925QtIAknlolWGnvrFZlQsL68aSU9p+F11sdvfdZaVscokoOPAlW/XDptqxpJGg8Wm29ts5hYIkYMs25hdb/9+pmuGiK7TezWJU73ePIrJCG1UW6O3udlGlXv2dBXuviU1EkbooLOB9GcVT7j6L2TU5rljsk76zsG8WE0n26yzynwOjCaOvwoK/klYMEetUFv6nqiJIdpVl+HugzXKFPrIkt0W2WP0fLM3zCSzV5S9L9E4aC/Vys1SfpLHMZJbtxxwWGcny/ZjDEiPdEuKnWSzQ+S9L+V5a05X9wZK+nMBkuT+ztDfaTRXtMctbnWgm2yWWenUTjWC5O1ObpqxTcnw3tknivWHpzzHJSZa/q4Yp2jGC71ObIKkCAW80wQUGsZbfajOKXyL8lOgtDDzNTyMZx68Z/JJJAYJ3+2UHI/m3nh8KqFDwxUDDQrcwlo5mhhVhNK/ZDLLtgcPRyKBCKhx8IciYDYznv2qGpHQCwnsMGcWIOtIaEPkzJDzdgNqM6atovp0Ghev4lNqFyppAX/owqj8S+nIaFu7mQ2Y3LrsD9Y1mXH8l0XcYGO6gK6EDmY26ajKyr2PrWQ4N59Fhv4BNRx3pVWx26qjH2L6L7W0uOGpub0fB4XpeEv9CZ6aXnIzu2VCtBvB8iqs1BB7OpHUYn4pa5/Fpo/UDnylajO8OjQwAXdWoC9BbjWYA/YGJbR7LEErksROhXB4HESrocQShih5H/yfVgqkZTE1hqgxTRY9DMB1AKJ/HWoQyeYxCKIFHM4TIszFAikZVgB5pxAHorAap+GzV+o7PBK2j+LTU2opPSa328DhSa9WC50V0rfTwHCXt+D/QmeiF9qNT09tAcJzpvVUA54HdW1InNuvIu+0KNi10UG9o3Bn1FIPmemQ9ib4gs4x0b0Cmhr4OwDyJoS/+H1zWk4+bcKnnS3NYHkb4EvMrKgvJ552olPOtIChPg3wLv4ZJDzKwNSTf4xgR8RGRxWToJECcuY3JpOCxNcgYWgaHuzgZnF1BY2OYUTQbDHcBMjytgsWeEONoLhSOXOTHiHdITCG/9lJxeJfMP7ZLOLQlP2eC4Y7NXzQNBDUH+d3+AoMxZMIqDgQehpqBhgHwPTuZMtp56andyKQZnbI7EWAWqiC5V9HJvJOlpuQiE9u2S8zZmEyd6KS01EFk8kxPZbUmxGyU74OctkYn8xf5IqN98cmKRb7L50p0smYFRTZXopNVs3yRy9HoZN18b2WyLT5ZOc1taaizopK1Y5yWxL8eAWT10CkuGbytTCJsqojvchoSY+4ngnMstZMoE0z4I7LX9Umk5Z4Ky7k5Hok10SxVTK/bBZBwMx0S0NdRcUjEQc2vCObPmpwkanuvuwJxby5KIg/veVcVw79NRUn0kcof/2M9ZXimEJJhjgkPLOU6VDcBSdNeYdlTizjPd0sfRpLNOP6Uw2Tqmw1NwknOQfkH7LvrModyalbdxCT7VHWajp231PD5M8Z0qlswCgkQAFZQOCCmCQAA0DoAnQEqqACoAD6NOpdHv6OiIS+XnMPwEYlmCHABg7Z3u/y0/Wf4D9yPbgsf+d/r3GfVh5+fP3np9F3mIfq70vPMB+xPrFf8f13f331AP8l/OfWy/63ss+gX+sHpzeyt/ZP+p6WnqAf//UAP0A4/2HjtpxSMYLy+Jjnmz7jm3qgaq7a4XiyYahC7Pwx4PdaVBZ6Rrxh6NFcUEwZcJY4hptzqa88ZITV81ALY2b7ux5Sc6irf3/A0e1x5xZO44kIn+jXV+52P35PL6cNX2Iki2F5xSw+l5nXO71+NuWH3eJatMFwcLCvcYjFxXYnFexvk6/lFmN6Lvzg+gpvxoFSY/QajUOXBFzhb/9fpxShn7ayklyXs1HbnrlV9PmZuU71G8tZhvQ+8lnndwP2eW/O6IfJhueJQBcACtXfzMYZUD+2nXUOu22XwErd33WWs3jtFmQoJBMaBs99HysoVGyiY94rPH/k8brC8vB7NF9Fk/05KQ2FK9rN/5ai2vRFRC6SO/V1VQvhQvXTUPvZMMjM8wnoVetUJIiAIDzaaO4PYLuHFQexboqx/SJkiTmzaj7nn1EA65bVnJ7Zilh3zIpJeFnDsmyhxoR8/l0CIIecj31nu0bAaXTpAcBGH0FKZxgAA/tHGD9UhmBUfQLO9MYkvqYf9NZg2fsF3s/kiFDZSIBfMPXNrVilOLGwMew6uh5TkTL0xX3HA+JuyRDMhFUE48XMgw5UaRju/5cTabjh66dKbdgJOUlDxTJUkTNo7TaNUCMokxdWG79cMhtrgWQKR9kXw5IkrVtSQumhmYeDfUeMMg6EWnXzz/C4gjbFP7dYkt8sblvV2ZcZyfbSrLoMSN1cPyCXXYkJQyHJJuVkGlWNoVvI+XthUh4L++Df//qDv/6jW//6hCQzK3y1PB/fwI8cfx6XKPEl9+KBF7Z0wljAXteMWQDEhr+xHvyiTWw6lEb5DNH2iV55L4Ia017aKXLSLKDVxA3sTlF6mZ4dASUmIbLuxBUyPjArupNUxC8s5KMkZq65SWSbFZM0YKY+WM+ij2guIde1o1H1Yv5VbKjRLOoqwqDw/dLcJMrdagIlv1Wk1Jx41SaaWIea060k23Lu9+L0ZQzZLSCYxwlWvCb/rC/3mYL/M6ayJANmP+WjKAdcjoIVQP7o+PXQZcdSPfL+A2pkY13xpmEQIIO3MDbXilXE/niR+J6pddU9uH2alEdT7BmCbIVCZU5L/TFc/+3PpkvoCV3G7FF5cT9xgXcO3bNw8xAP7sTbKIbK67ieZ4GCcpgH2iWZ/8np89SXHRckefwhQPRNctlvx90eoA1zIrYVvc+3nCnycu/N5sZGAC7xws8dbhjKCkcAPhS1CmKeLxbybxiBS/17a8mE8A97q0f4sbG2RWj/cTVWaaEe6XJNJWjCz7wmYRx1TdRa42pxhGvRZ8uxawVO5DXHOXO5EniMI/fzc9wbHCDBJXnoK3uuoJ4BGOwlr85FhJEHZyr8JH/rYWQ2J7X+nzuEakK4jPNjFcMXQJ7K51Cr1cNJ9sAC6rP4svOZiDrU3nziukWOUzx5lRoUmrIoPlGBK2As3B2kS61V7jGVmAZAM9v0ekcCWlkB0TFFqE2TtfiHv7IwkFROiv/8fcG+L92e955DswM4bvS0kmj7JN63CuMulmI75MSAgx6/PYGtchAMGbXGmavBIbH+InoBLM/fJK9ACSRwozuJofPWh3pZpcfbGcjnmYgOkk6e98Azkz9PF0gzdYNNfJDFlxICBte3ypWtW2HNAL5VtXlgvCX80fQz4YFXeHeHof7/PnnmlJLObrcOw8COzS3a4DuANIoa7ZYF1zOn7UbP4vYtctLcpesvzBWDzeMw8bgOz1VTBdGB6OSXqZoAXyHqFQJqliZXYEni/7tuK9q0f4jmT+02Q0PUaeZXYp7govBNBVTdzjuLBg/BijJZLb8AKFqamYQ7gh7o679ZnhO0C6WvuoPQnT7iNRA07HhmkW5Z27AHkMdzTYTjGCg3Rs55qHedhO4V59r4ujYqwXggq7nOLQNoaSAPn5Jgf46QblNiQAKDhe+rsSkRVJuK2vcs115d3coukQmfT7toJu/ULerYM8ygrNP05fTv+8BcFKVVq8QNYFExLFZgq8pMeQa61ebnk2Yf0Rn7R76+RdKhWJqz2DtLHOcfS9Bc5fjLyt6vuI3iMRuUCU8PtnbEWZcnOX7UKxhj6luLvNfuEA+YgTxmCa+ia/rfbjX8bKwNA9VO8B6QKL4gEhY1zjljJV2bVbpcBAQlp6DXy4nrqDFdDw+rgqU4Aut80XyT7uy06ZVZqdqNy2PrAM17tYioA1TEtWqMnwOawzfXEzRpOtte9ujnipV8Lmc9J/5JaiTJEm4zJzVBD/fvZ6TRYADyttL5bP816aEzAXrs1Cdha7yz+K9wiC3fGJ1ncmE9SDp9Y4A4av4l4QbH2ACu8uZ18XG3YClrCF+zq8nOEXKNFooKv3BVk87MyPhsoL20rJmj0B/FhaPUE8FEKuTIytui/f+9ffRp8JGXGebJkhXbQxcbQpjMhB1N/R2Ln9E/q5AobAzj0enhfTJZ4cHdUi3ZIcR3uHrz9KIPLFPpVHg1tu0C++ynDXOB/vw7//+QZOT+MV4UIjGuIYuN+7EDgQSN2Q2rMBPaIGruPOOhWjJf7LhbrYwqJwUt9i/LFQLnge/3pT+usIIoDjadirZmKE+P3CPy+nTKBcXx50zHhhCNRHsTuSOlJkFgdUsZqyhH/Dj96jXgHZCioELE1p6JQVf7eUHdkP0kuyjWZZBrgNHOGdgV5pbCMsEZJPnPngdada7meSEcxmBpVDDMtBFnEWlf0KMvUYju1W2eUZAaJf/QoE0jVlzcFo8fb/VkS94bEqH/CvzICyGKpp3oehjFNTeAxVQ1mo5wC9NtMs9qNmziOpl1TlLQyq5SZOeoT1vymiEdDwDMcAOn4yJNxYbCMyVUESlY0WQ+pyu0Fg4VIOGvfB5ELPbX+Bul/kZI3cGGj3bvT+SIwMgbYBE+UMF7G3no7szTtKpBKayN7Q/dJdR3qP2ityS2Of/ggiC+pRl2YIAIDP//D+6sE3axpGG16234DrgDHIQmeelSQFOtOSZIuX+YHjIudSk8pCt0HU5HacwDEAyWwNFWBFrZBT0gMzG57jQGhraSbPQ49jh+7oeBOTVvlpQszV27Njk0Tds1+V5mFcG+wsoDBh212/MPF4TB4FNlhffR97jggaZmNoIJtNZ+IA++6R2NiGcWnq4XyL0yiLbYrAlLb1cuf+hbgAAAAAA=="
                loading="lazy"
                class="icon-inner coin-amount animate-check"
                alt=""
              >
            </div>
            <div class="step-2">
              <div style="font-size: 8px; color: #000">
                ยอดเงินของคุณ
              </div>
              <div style="font-size: 14px; color: #105FA6; font-weight: 600;">
                {{ Commas(MainWallet) }} <span style="font-size: 0.8rem;">{{ UserData.currency }}</span>
              </div>
            </div>
          </div>

          <button
            class="btn bg-transparent p-0 x-hamburger js-hamburger-toggle collapsed"
            style="overflow-anchor: none"
            @click="showModal"
          >
            <span />
            <span />
            <span />
          </button>
          <!-- <div
            class="nav-side cursor-pointer d-flex align-items-center"
            @click="showModal"
          >
            <i class="fas fa-bars" />
          </div> -->
        </div>
      </div>
    </header>

    <b-modal
      ref="my-modal"
      hide-footer
      hide-header
      centered
      size="sm"
    >
      <div class="position-relative">
        <i
          class="far fa-times position-absolute right-0 cursor-pointer"
          style="font-size: 20px;"
          @click="hideModal"
        />
        <div class="hd-h2 text-center">
          <h3 class="text-black">
            เมนูหลัก
          </h3>
        </div>

        <div class="-modal-profile-mobile">
          <!-- <div class="text-center">
            <img
              src="/logo/logo.png"
              class="p-2"
            >
          </div> -->
          <ul class="navbar-navs">
            <li
              v-if="
                UserData &&
                  UserData.usertype == 'member' &&
                  UserData.userID != 10052
              "
              class="nav-item ng-star-inserted"
            >
              <router-link :to="{ name: 'tanghuay-home' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/home.png"
                    alt="ic-menu-user"
                    class="-icon-image"
                    height="35"
                  ><span class="-text-menu"> หน้าหลัก </span>
                </button>
              </router-link>
            </li>

            <li
              v-if="
                UserData &&
                  UserData.usertype == 'member' &&
                  UserData.userID != 10052
              "
              class="nav-item ng-star-inserted"
            >
              <router-link :to="{ name: 'tanghuay-deposit' }">
                <button
                  type="button"
                  class="nav-links js-close-account-sidebar"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/ic-mobile-right-1.webp"
                    alt="ic-menu-user"
                    class="-icon-image"
                    height="35"
                  ><span class="-text-menu"> เติมเงิน </span>
                </button>
              </router-link>
            </li>

            <li
              v-if="
                UserData &&
                  UserData.usertype == 'member' &&
                  UserData.userID != 10052
              "
              class="nav-item ng-star-inserted"
            >
              <router-link :to="{ name: 'tanghuay-withdraw' }">
                <button
                  type="button"
                  class="nav-links btn-gold-2"
                  tabindex="0"
                >
                  <img
                    src="@/assets/newImg/download.webp"
                    alt="ic-menu-user"
                    class="-icon-image"
                    height="35"
                  ><span class="-text-menu"> ถอนเงิน </span>
                </button>
              </router-link>
            </li>

            <li class="nav-item ng-star-inserted">
              <router-link :to="{ name: 'tanghuay-round' }">
                <button
                  type="button"
                  class="nav-links btn-gold-2"
                  tabindex="0"
                  @click="hideModal"
                >
                  <img
                    src="@/assets/newImg/we.webp"
                    alt="ic-menu-user"
                    class="-icon-image"
                    height="35"
                  ><span class="-text-menu"> แทงหวย </span>
                </button>
              </router-link>
            </li>

            <li class="nav-item ng-star-inserted">
              <router-link :to="{ name: 'tanghuay-list' }">
                <button
                  type="button"
                  class="nav-links btn-gold-2"
                  tabindex="0"
                  @click="hideModal"
                >
                  <img
                    src="@/assets/newImg/doc.png"
                    alt="ic-menu-user"
                    class="-icon-image"
                    height="35"
                  >
                  <span class="-text-menu"> โพยของฉัน </span>
                </button>
              </router-link>
            </li>

            <!-- <li class="nav-item ng-star-inserted">
              <button
                v-if="PrintAuto"
                type="button"
                class="nav-links btn-gold-2"
                tabindex="0"
                @click="ChangPrintAuto"
              >
                <img
                  src="@/assets/newImg/print01.png"
                  alt="ic-menu-user"
                  class="-icon-image"
                  height="35"
                >
                <span class="-text-menu"> ปริ้นโพยอัตโนมัติ</span>
              </button>
              <button
                v-else
                type="button"
                class="nav-links btn-gold-2"
                tabindex="0"
                @click="ChangPrintAuto"
              >
                <img
                  src="@/assets/newImg/Unprint.png"
                  alt="ic-menu-user"
                  class="-icon-image"
                  height="35"
                >
                <span class="-text-menu"> ปิดปริ้นโพยอัตโนมัติ </span>
              </button>
            </li> -->
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBToggle } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from '@/libs/acl/config'

export default {
  components: {
    BModal,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      Interval: null,
      IntervalWallet: null,
      MainWallet: 0,
      // isScrolled: false,
      UserData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    PrintAuto() {
      return this.$store.state.app.printListAuto
    },
  },
  beforeDestroy() {
    clearInterval(this.Interval)
  },
  mounted() {
    this.ShowWallet()
    this.Interval = setInterval(() => {
      this.ShowWallet()
    }, 30000)
    this.IntervalWallet = setInterval(() => {
      this.ShowWalletNow()
    }, 500)
    // window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    // handleScroll() {
    //   this.isScrolled = window.scrollY > 1
    // },
    ChangPrintAuto() {
      this.$store.commit('app/UPDATE_PRINTLIST', !this.PrintAuto)
    },
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    toggleModal() {
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
    async ShowWalletNow() {
      this.MainWallet = this.$store.state.appConfig.UserData.Balance
      this.discount = this.$store.state.appConfig.UserData.Discount
    },
    async ShowWallet() {
      try {
        const params = {
          UserToken: localStorage.getItem('UserToken'),
        }
        const { data: response } = await this.$http.get(
          '/seamless/wallet/show',
          { params },
        )
        if (response && response.success === true) {
          const Main = response.WalletData
          this.MainWallet = Main.balance
          this.$store.state.appConfig.UserData = {
            Balance: Main.balance,
            Discount: response.discount,
          }
          if (
            Number(this.UserData.count_login) !== Number(response.count_login)
          ) {
            localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
            localStorage.removeItem(
              useJwt.jwtConfig.storageRefreshTokenKeyName,
            )
            localStorage.removeItem('userData')
            localStorage.removeItem('UserToken')
            localStorage.removeItem('BreakToken')
            this.$ability.update(initialAbility)
            window.location.href = this.UserData.site
          }
        } else {
          this.MainWallet = 0
          this.$store.state.appConfig.UserData = { Balance: 0, Discount: 0 }
        }
      } catch (err) {
        console.log(err)
      }
    },
    Commas(x) {
      if (Math.round(x) !== x && x > 0) {
        const Num = Number(x)
        const y = Num.toFixed(2)
        return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // async ShowWallet() {
    //   this.MainWallet = this.$store.state.appConfig.UserData.Balance
    //   this.discount = this.$store.state.appConfig.UserData.Discount
    // },
  },
}
</script>

<style scoped>
.steper {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  gap: 0.75rem;
  height: 40px;
  width: 210px;
  border-radius: 10px;
  transition-duration: 200ms;
  cursor: pointer;
}
.steper:hover {
  transform: scale(0.95);
  /* background-color: rgba(0, 0, 0, 0.2); */
}

.step-2 {
  display: flex;
  flex-direction: column;
}
.x-hamburger {
  width: 25px;
  height: 28px;
  position: relative;
  transition: 0.5s ease-in-out;
}
.coin-amount {
  animation: spinCoin 5s linear 2s infinite;
  height: 30px;
}
@keyframes spinCoin {
  0% {
    transform: rotateY(0);
  }
  25% {
    transform: rotateY(180deg);
  }
  50% {
    transform: rotateY(1turn);
  }
  to {
    transform: rotateY(0);
  }
}
.x-hamburger {
  transform: rotate(0deg);
  cursor: pointer;
}

@media (max-width: 575.98px) {
  .x-hamburger {
    width: 20px;
  }
}

.x-hamburger span {
  margin-top: 3px;
  width: 70%;
  display: block;
  position: absolute;
  height: 3px;
  opacity: 1;
  transition: 0.25s ease-in-out;
}

.x-hamburger span {
  background: #105FA6;
  border-radius: 9px;
  transform: rotate(0deg);
}

.x-hamburger span {
  left: 0;
}

.x-hamburger span {
  right: 0;
}

.x-hamburger span:first-child {
  top: 0;
}

.x-hamburger span:first-child,
.x-hamburger span:first-child {
  animation: x-hamburger-wave 0.4s ease-out infinite alternate;
}

.x-hamburger span:first-child,
.x-hamburger span:nth-child(2) {
  transform-origin: left center;
}

.x-hamburger span:first-child,
.x-hamburger span:nth-child(2) {
  transform-origin: right center;
}

.x-hamburger span:nth-child(2) {
  top: 9px;
}

.x-hamburger span:nth-child(2),
.x-hamburger span:nth-child(2) {
  animation: x-hamburger-wave 0.4s ease-out 0.3s infinite alternate;
}

.x-hamburger span:nth-child(3) {
  top: 18px;
}

.x-hamburger span:nth-child(3) {
  transform-origin: left center;
  animation: x-hamburger-wave 0.4s ease-out 0.6s infinite alternate;
}

.x-hamburger span:nth-child(3) {
  transform-origin: right center;
  animation: x-hamburger-wave 0.4s ease-out 0.6s infinite alternate;
}

@media (max-width: 575.98px) {
  .x-hamburger span:nth-child(2) {
    top: 7px;
  }

  .x-hamburger span:nth-child(3) {
    top: 14px;
  }
}

@keyframes x-hamburger-wave {
  0% {
    width: 70%;
  }

  to {
    width: 100%;
  }
}
</style>
